export default __webpack_public_path__ + "static/media/z040mi0a.107f5bb5.mp3";